module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calls-result"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Контактов в базе")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.fullCount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Дозвонились до")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.predefinedCount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ответили на первый вопрос")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.firstQuestionAnsweredCount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Сценарий завершён")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.dialogToEndCount))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07411758"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/campaigns/CampaignCallsResult.vue
// module id = 457
// module chunks = 42